import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { RouterModule } from "@angular/router";

import {
  ImpersonationBarContainerComponent,
  ImpersonationService
} from "@frontends-v3/shared-core";

/**
 * CA02 (DEV-871): a barra de personificação mora aqui, no root, e não no shell (navbar) — é o que
 * faz a rota que vive fora do shell (/enrichment) também anunciar a sessão personificada. A barra
 * só se renderiza quando há personificação ativa.
 */
@Component({
  imports: [RouterModule, ImpersonationBarContainerComponent],
  selector: "app-root",
  templateUrl: "./app.html",
  styleUrl: "./app.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { "[class.has-impersonation-bar]": "isImpersonating()" }
})
export class App {
  private readonly impersonationService = inject(ImpersonationService);

  // A classe no host é o que faz as telas dimensionadas pela viewport descontarem a altura da
  // barra (ver app.scss): fora da personificação nada muda.
  protected readonly isImpersonating = this.impersonationService.isImpersonating;
}
